import React from 'react';
import AddBoxIcon from "@material-ui/icons/AddBox";
import IconButton from "@material-ui/core/IconButton";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

export const AddButton = ({onClick, disabled}) => {
    return <IconButton onClick={onClick} disabled={disabled}>
        <AddBoxIcon/>
    </IconButton>
}

